export const getCarrier = (sub) => {
  if (!sub) {
    return "";
  }

  if (sub.att_status) {
    return "att";
  } else if (sub.quick_status) {
    return "quick";
  } else if (sub.sprint_status) {
    return "sprint";
  }

  return "";
};

export const formatMdn = (mdn) => {
  if (!mdn) {
    return '';
  }

  if (mdn.length !== 10) {
    return mdn;
  }

  return `(${mdn.slice(0, 3)}) ${mdn.slice(3, 6)}-${mdn.slice(6)}`;
};

